import React, { useState } from 'react';
import { OfficerLayout } from '../../components/layout/OfficerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Textarea } from '../../components/ui/Textarea';
import { Modal } from '../../components/ui/Modal';
import { AlertTriangle, Camera, MapPin, Clock, CheckCircle2, Search, Filter, ChevronRight, Send, MoreHorizontal, Image as ImageIcon } from 'lucide-react';
import { cn } from '../../lib/utils';
export function IsuLapanganPage() {
  const [activeTab, setActiveTab] = useState<'create' | 'history'>('create');
  const [selectedIssue, setSelectedIssue] = useState<any | null>(null);
  const [urgency, setUrgency] = useState('Sedang');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const mockHistory = [{
    id: 'TKT-8821',
    title: 'Penolakan Warga RT 02',
    status: 'process',
    date: '2 jam lalu',
    urgency: 'Tinggi',
    description: 'Warga menolak penempatan tong sampah terpilah karena alasan bau dan mengganggu akses jalan.',
    location: 'RT 02 RW 05, Kel. Sukasari',
    timeline: [{
      time: '10:00',
      status: 'Tiket Dibuat',
      user: 'Budi Santoso'
    }, {
      time: '10:15',
      status: 'Diterima Admin',
      user: 'System'
    }, {
      time: '10:30',
      status: 'Sedang Diproses',
      user: 'Admin Wilayah'
    }]
  }, {
    id: 'TKT-8815',
    title: 'Kekurangan Karung Pilah',
    status: 'done',
    date: 'Kemarin',
    urgency: 'Sedang',
    description: 'Stok karung untuk bank sampah habis, mohon dikirim segera sebanyak 50 pcs.',
    location: 'Bank Sampah Melati',
    resolution: 'Karung telah dikirim oleh tim logistik pada pukul 14:00.',
    timeline: [{
      time: 'Kemarin, 09:00',
      status: 'Tiket Dibuat',
      user: 'Budi Santoso'
    }, {
      time: 'Kemarin, 14:00',
      status: 'Selesai',
      user: 'Logistik'
    }]
  }, {
    id: 'TKT-8810',
    title: 'Hoaks Isu Pencemaran',
    status: 'pending',
    date: '2 hari lalu',
    urgency: 'Rendah',
    description: 'Beredar info palsu di grup WA warga tentang pencemaran air tanah.',
    location: 'RW 07',
    timeline: [{
      time: '2 Feb, 08:00',
      status: 'Tiket Dibuat',
      user: 'Budi Santoso'
    }]
  }];
  const filteredHistory = mockHistory.filter(item => {
    const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase());
    if (filterStatus === 'all') return matchesSearch;
    return matchesSearch && item.status === filterStatus;
  });
  return <OfficerLayout title="Lapor Isu Lapangan" data-id="element-3052">
      {/* Tabs */}
      <div className="flex p-1 bg-gray-100 rounded-lg mb-6" data-id="element-3053">
        <button className={cn('flex-1 py-2 text-sm font-medium rounded-md transition-all', activeTab === 'create' ? 'bg-white shadow text-primary-600' : 'text-gray-500')} onClick={() => setActiveTab('create')} data-id="element-3054">
          Buat Tiket
        </button>
        <button className={cn('flex-1 py-2 text-sm font-medium rounded-md transition-all', activeTab === 'history' ? 'bg-white shadow text-primary-600' : 'text-gray-500')} onClick={() => setActiveTab('history')} data-id="element-3055">
          Riwayat
        </button>
      </div>

      {activeTab === 'create' ? <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-3056">
          {/* Statistics Card */}
          <div className="grid grid-cols-3 gap-3" data-id="element-3057">
            <div className="bg-blue-50 p-3 rounded-lg border border-blue-100 text-center" data-id="element-3058">
              <p className="text-xs text-blue-600 font-medium" data-id="element-3059">Total Isu</p>
              <p className="text-xl font-bold text-blue-700" data-id="element-3060">12</p>
            </div>
            <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-100 text-center" data-id="element-3061">
              <p className="text-xs text-yellow-600 font-medium" data-id="element-3062">Proses</p>
              <p className="text-xl font-bold text-yellow-700" data-id="element-3063">3</p>
            </div>
            <div className="bg-green-50 p-3 rounded-lg border border-green-100 text-center" data-id="element-3064">
              <p className="text-xs text-green-600 font-medium" data-id="element-3065">Selesai</p>
              <p className="text-xl font-bold text-green-700" data-id="element-3066">9</p>
            </div>
          </div>

          {/* Form Section */}
          <Card className="border-l-4 border-l-red-500 shadow-md" data-id="element-3067">
            <CardContent className="p-4 space-y-4" data-id="element-3068">
              <h3 className="font-bold text-gray-900 flex items-center" data-id="element-3069">
                <AlertTriangle className="h-4 w-4 text-red-500 mr-2" data-id="element-3070" />
                Buat Tiket Isu Baru
              </h3>

              <div className="space-y-2" data-id="element-3071">
                <label className="text-sm font-medium text-gray-700" data-id="element-3072">
                  Jenis Isu <span className="text-red-500" data-id="element-3073">*</span>
                </label>
                <Select data-id="element-3074">
                  <option value="" data-id="element-3075">-- Pilih Kategori --</option>
                  <option value="hoaks" data-id="element-3076">Hoaks / Disinformasi</option>
                  <option value="resistensi" data-id="element-3077">Penolakan Warga</option>
                  <option value="teknis" data-id="element-3078">Kendala Teknis</option>
                  <option value="darurat" data-id="element-3079">Darurat Lingkungan</option>
                  <option value="logistik" data-id="element-3080">Kekurangan Logistik</option>
                </Select>
              </div>

              <div className="space-y-2" data-id="element-3081">
                <label className="text-sm font-medium text-gray-700" data-id="element-3082">
                  Urgensi
                </label>
                <div className="flex gap-2" data-id="element-3083">
                  {['Rendah', 'Sedang', 'Tinggi'].map(level => <button key={level} onClick={() => setUrgency(level)} className={cn('flex-1 py-2 text-xs font-medium rounded-md border transition-colors', urgency === level ? level === 'Tinggi' ? 'bg-red-50 border-red-500 text-red-700' : level === 'Sedang' ? 'bg-yellow-50 border-yellow-500 text-yellow-700' : 'bg-blue-50 border-blue-500 text-blue-700' : 'bg-white hover:bg-gray-50 text-gray-600')} data-id="element-3084">
                      {level}
                    </button>)}
                </div>
              </div>

              <div className="space-y-2" data-id="element-3085">
                <label className="text-sm font-medium text-gray-700" data-id="element-3086">
                  Deskripsi <span className="text-red-500" data-id="element-3087">*</span>
                </label>
                <Textarea placeholder="Jelaskan isu yang ditemukan secara detail..." className="h-24" data-id="element-3088" />
                <p className="text-xs text-gray-400 text-right" data-id="element-3089">
                  0/500 karakter
                </p>
              </div>

              <div className="grid grid-cols-2 gap-3" data-id="element-3090">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center text-center bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer" data-id="element-3091">
                  <Camera className="h-6 w-6 text-gray-400 mb-1" data-id="element-3092" />
                  <span className="text-xs text-gray-500" data-id="element-3093">Ambil Foto</span>
                </div>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center text-center bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer" data-id="element-3094">
                  <MapPin className="h-6 w-6 text-gray-400 mb-1" data-id="element-3095" />
                  <span className="text-xs text-gray-500" data-id="element-3096">Lokasi</span>
                </div>
              </div>

              <Button className="w-full bg-red-600 hover:bg-red-700 text-white shadow-md active:scale-95 transition-all" data-id="element-3097">
                <Send className="h-4 w-4 mr-2" data-id="element-3098" /> Kirim Tiket
              </Button>
            </CardContent>
          </Card>

          {/* Urgent Escalation */}
          <div className="bg-red-50 p-4 rounded-lg border border-red-100 flex items-start gap-3" data-id="element-3099">
            <AlertTriangle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-3100" />
            <div data-id="element-3101">
              <h4 className="text-sm font-bold text-red-800" data-id="element-3102">
                Butuh Respon Cepat?
              </h4>
              <p className="text-xs text-red-700 mt-1 mb-2" data-id="element-3103">
                Gunakan tombol eskalasi untuk isu yang membahayakan keselamatan
                atau darurat lingkungan.
              </p>
              <Button size="sm" variant="outline" className="bg-white border-red-200 text-red-700 h-8 text-xs" data-id="element-3104">
                Hubungi Hotline Pusat
              </Button>
            </div>
          </div>
        </div> : <div className="space-y-4 animate-in fade-in duration-300" data-id="element-3105">
          {/* Search & Filter */}
          <div className="space-y-3" data-id="element-3106">
            <div className="relative" data-id="element-3107">
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-3108" />
              <Input placeholder="Cari tiket..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-3109" />
            </div>
            <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar" data-id="element-3110">
              {['all', 'pending', 'process', 'done'].map(status => <button key={status} onClick={() => setFilterStatus(status)} className={cn('px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors', filterStatus === status ? 'bg-gray-800 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50')} data-id="element-3111">
                  {status === 'all' ? 'Semua' : status === 'pending' ? 'Menunggu' : status === 'process' ? 'Diproses' : 'Selesai'}
                </button>)}
            </div>
          </div>

          {/* List */}
          <div className="space-y-3" data-id="element-3112">
            {filteredHistory.map(item => <Card key={item.id} className="active:bg-gray-50 transition-colors cursor-pointer" onClick={() => setSelectedIssue(item)} data-id="element-3113">
                <div className="p-4" data-id="element-3114">
                  <div className="flex justify-between items-start mb-2" data-id="element-3115">
                    <Badge variant={item.status === 'done' ? 'success' : item.status === 'process' ? 'warning' : 'secondary'} className="text-[10px]" data-id="element-3116">
                      {item.status === 'done' ? 'Selesai' : item.status === 'process' ? 'Diproses' : 'Menunggu'}
                    </Badge>
                    <span className="text-xs text-gray-500" data-id="element-3117">{item.date}</span>
                  </div>
                  <h4 className="text-sm font-bold text-gray-900 mb-1" data-id="element-3118">
                    {item.title}
                  </h4>
                  <div className="flex items-center gap-2 mb-2" data-id="element-3119">
                    <Badge variant="outline" className={`text-[10px] px-1.5 py-0 ${item.urgency === 'Tinggi' ? 'text-red-600 border-red-200 bg-red-50' : item.urgency === 'Sedang' ? 'text-yellow-600 border-yellow-200 bg-yellow-50' : 'text-blue-600 border-blue-200 bg-blue-50'}`} data-id="element-3120">
                      {item.urgency}
                    </Badge>
                    <span className="text-xs text-gray-500 font-mono" data-id="element-3121">
                      {item.id}
                    </span>
                  </div>
                  <p className="text-xs text-gray-600 line-clamp-2" data-id="element-3122">
                    {item.description}
                  </p>
                </div>
              </Card>)}
          </div>
        </div>}

      {/* Issue Detail Modal */}
      <Modal isOpen={!!selectedIssue} onClose={() => setSelectedIssue(null)} title={`Detail Tiket #${selectedIssue?.id}`} size="sm" className="mb-0 rounded-b-none sm:rounded-b-lg sm:mb-auto fixed bottom-0 sm:relative w-full sm:w-auto" data-id="element-3123">
        {selectedIssue && <div className="space-y-4" data-id="element-3124">
            <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border" data-id="element-3125">
              <span className="text-sm text-gray-600" data-id="element-3126">Status</span>
              <Badge variant={selectedIssue.status === 'done' ? 'success' : selectedIssue.status === 'process' ? 'warning' : 'secondary'} data-id="element-3127">
                {selectedIssue.status === 'done' ? 'Selesai' : selectedIssue.status === 'process' ? 'Diproses' : 'Menunggu'}
              </Badge>
            </div>

            <div data-id="element-3128">
              <h4 className="font-bold text-gray-900 mb-1" data-id="element-3129">
                {selectedIssue.title}
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-3130">
                {selectedIssue.description}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-3131">
              <div data-id="element-3132">
                <p className="text-xs text-gray-500" data-id="element-3133">Lokasi</p>
                <p className="font-medium flex items-center gap-1" data-id="element-3134">
                  <MapPin className="h-3 w-3" data-id="element-3135" /> {selectedIssue.location}
                </p>
              </div>
              <div data-id="element-3136">
                <p className="text-xs text-gray-500" data-id="element-3137">Urgensi</p>
                <p className={`font-medium ${selectedIssue.urgency === 'Tinggi' ? 'text-red-600' : 'text-gray-900'}`} data-id="element-3138">
                  {selectedIssue.urgency}
                </p>
              </div>
            </div>

            <div data-id="element-3139">
              <h4 className="font-medium text-gray-900 mb-2" data-id="element-3140">Bukti Foto</h4>
              <div className="flex gap-2 overflow-x-auto pb-2" data-id="element-3141">
                <div className="h-20 w-20 bg-gray-200 rounded-lg flex-shrink-0 flex items-center justify-center" data-id="element-3142">
                  <ImageIcon className="h-6 w-6 text-gray-400" data-id="element-3143" />
                </div>
                <div className="h-20 w-20 bg-gray-200 rounded-lg flex-shrink-0" data-id="element-3144"></div>
              </div>
            </div>

            {selectedIssue.resolution && <div className="bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-3145">
                <h4 className="text-xs font-bold text-green-800 mb-1" data-id="element-3146">
                  Penyelesaian:
                </h4>
                <p className="text-sm text-green-700" data-id="element-3147">
                  {selectedIssue.resolution}
                </p>
              </div>}

            <div data-id="element-3148">
              <h4 className="font-medium text-gray-900 mb-2" data-id="element-3149">Timeline</h4>
              <div className="space-y-3 pl-2 border-l-2 border-gray-200 ml-1" data-id="element-3150">
                {selectedIssue.timeline.map((event: any, i: number) => <div key={i} className="relative pl-4" data-id="element-3151">
                    <div className="absolute -left-[9px] top-1.5 h-4 w-4 rounded-full bg-white border-2 border-primary-500" data-id="element-3152"></div>
                    <p className="text-xs text-gray-500" data-id="element-3153">{event.time}</p>
                    <p className="text-sm font-medium text-gray-900" data-id="element-3154">
                      {event.status}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-3155">Oleh: {event.user}</p>
                  </div>)}
              </div>
            </div>

            <Button className="w-full" variant="outline" onClick={() => setSelectedIssue(null)} data-id="element-3156">
              Tutup
            </Button>
          </div>}
      </Modal>
    </OfficerLayout>;
}